<template>
 <div class="pc_only">
    <h2 class="kojin-title">{{ shakyo_name }}社協プライバシーポリシー</h2>
  </div>
  
  <span class="sp_only">
      <span class="sp-title" style="color:#FFF;background: #FF8400;" v-on:click="return_page()">
        ← {{ shakyo_name }}社協プライバシーポリシー
      </span>
    </span>
  <div class="p-2" style="margin-top:0;background-color:white" >
    <!-- パンくずリスト -->
    <nav style="--bs-breadcrumb-divider: '>';" aria-label="breadcrumb" class="pc_only">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" v-on:click="home" style="cursor:pointer">Home</li>
        <li class="breadcrumb-item active" aria-current="page">{{ shakyo_name }}社協プライバシーポリシー</li>
      </ol>
    </nav>

    <div class="p-4" style="text-align:left" >
      <h3><b>{{policy_title}}</b></h3><br>
      
      <div v-html="policy"></div>
      <br>
      <div v-html="policy_footer" style="width:100%;text-align:right">
      </div>
    </div>
      
    
   </div>
   
    
     <!-- スマホ専用ボタン（フローティングメニューの上に配置） -->
     <div class="vy-responsive-menu-container floating_over"  style="
          padding: 10px 0;
          margin-bottom:50px;
          background: rgba(0, 0, 0, .5);
          border: 0px;
          justify-content: space-evenly;">
          <button class="btn btn-primary mx-aut" style="width: 45%; height: 50px;padding: 0;background-color: white;color:#4175d0;border:1px solid #000"  v-on:click="return_page()">戻る</button>
          
      </div>
</template>

<script setup>
/* eslint-disable */

  import axios from 'axios'
import { GlobalData, login_check, logout } from '../js/userdata.js'
import { useRouter,useRoute } from 'vue-router'

import { ref, computed } from 'vue';
import { useStore } from 'vuex'
const router = useRouter()
const route = useRoute()
const emit = defineEmits(['call'])
emit('call',{cmd:'page_scroll'});
// URLから閲覧している社協の英名を取得
let cityname = route.params.shakyo

const store = useStore()
// 社協英名をstoreに保存
store.state.access_shakyo = cityname

let shakyo_name = ref("")

let policy = ref("")
let policy_title = ref("")
let policy_footer = ref("")

const home = () => { router.push('/'+cityname+'/Taiken') }

const return_page = () =>{
    if(router.go(-1)){
      router.go(-1)
    }else{
      window.close()

    }
  }

let shakyo_read_error = 0
  let shakyo_read = function(){
    // ユーザーの社協コードを利用して呼び出し
    axios.post(GlobalData.$API_URL+"Shakyo_read", 
              {shakyo:cityname}
             ).then(response => {
              shakyo_name.value = response["data"].shakyo_name
              if(response["data"].policy != "" && response["data"].policy != null && response["data"].policy != "None"){
                policy.value = response["data"].policy.replace(/\n/g, '<br>');
              }
              policy_title.value = response["data"].policy_title
              
              if(response["data"].policy_footer != "" && response["data"].policy_footer != null && response["data"].policy_footer != "None"){
                policy_footer.value = response["data"].policy_footer.replace(/\n/g, '<br>');
              }
            })
            .catch(error => {
                            if(shakyo_read_error == 6){
                                alert(error + GlobalData.$axios_error)
                            }else{
                                shakyo_read_error++
                                setTimeout(function(){
                                    shakyo_read()
                                },"1000")
                            }
                
            })
          }

    shakyo_read()
</script>

<style scoped>
/* レスポンシブ対応 */
@media screen and (max-width: 960px) {
  /*スマホ*/
  .jokyo_table {
    margin-top: 10px;
  }
.floating_over{
        display: flex
    }
}
@media screen and (min-width: 961px) {
  /*PC*/
  .jokyo_table {
    max-width: 700px;
  }
  .floating_over{
    display: none
  }
}
</style>
